/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ReactComponent as Search } from "cms/assets/icons/search.svg";
import { TextField } from "@mui/material";

const FilterSearch = (props) => {
    const { onChangeHandler, onSearchHandler, searchText } = props;
    return (
        <div className="search-query">
            <TextField
                placeholder="Search by permit number or street address"
                variant="outlined"
                sx={{
                    "& .MuiInputBase-root": {
                        height: "48px",
                        width: "444px",
                    },
                }}
                onChange={onChangeHandler}
                onKeyDown={(event) => {
                    if (event.key === "Enter") {
                        onSearchHandler();
                    }
                }}
                value={searchText}
            />
            <div className="search-cta">
                <button className="search-btn" onClick={onSearchHandler}>
                    <Search />
                </button>
            </div>
        </div>
    );
};

export { FilterSearch };
